import apiClient, { unwrap } from './client';

export const profileApi = {
  getMe: async () => {
    const res = await apiClient.get('/profiles/me');
    return unwrap(res);
  },

  updateMe: async (data) => {
    const res = await apiClient.put('/profiles/me', data);
    return unwrap(res);
  },

  changePassword: async (currentPassword, newPassword) => {
    await apiClient.put('/profiles/me/password', { currentPassword, newPassword });
  },

  getTeam: async () => {
    const res = await apiClient.get('/profiles/team');
    return unwrap(res) ?? [];
  },

  inviteMember: async (data) => {
    const res = await apiClient.post('/profiles/team', data);
    return unwrap(res);
  },

  removeMember: async (memberId) => {
    await apiClient.delete(`/profiles/team/${memberId}`);
  },

  updateMemberModules: async (memberId, allowedModules) => {
    const res = await apiClient.put(`/profiles/team/${memberId}/modules`, { allowedModules });
    return unwrap(res);
  },
};
